import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FidUiModule } from './fid-ui.module';
import { MaterialModule } from './material.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, FidUiModule, MaterialModule],
  exports: [FidUiModule, MaterialModule],
})
export class SharedModule {}
